import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { dto_common } from "../../../../classes/dto-common";
import { F_Fammily } from "../../../../util/config-fonts";
import { CSP } from "../../../../config/config";
import { buildEncryptedValueProps } from "../../../../functions/store_sessions";

function PriceDetail({
  SubTotal,
  Discount,
  ServiceCharge,
  TotalTax,
  DeliveryCharge,
  DeliveryDiscount,
  GrandTotal,
  Clear,
}) {
  const encryptedAmountProps = (amount) => buildEncryptedValueProps(amount);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "white",
        padding: "2%",
        color: "#333333",
      }}
      className="fadeInUp animated"
      data-wow-duration="300ms"
      data-wow-delay="0ms"
    >
      <div className="pgCartPrice">
        <p
          style={{
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Sub Total
        </p>
        <p
          style={{
            display:
              Discount === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Discount
        </p>
        <p
          style={{
            display:
              ServiceCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Service Charge
        </p>

        <p
          style={{
            display:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? "block"
                  : "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
            color:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? " #457856"
                  : ""
                : "",
            fontWeight:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? "bold"
                  : ""
                : "",
          }}
        >
          {DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
            ? CSP === "MK" && dto_common.DineType !== 3
              ? "Free Delivery"
              : "Delivery"
            : "Delivery"}
        </p>

        {CSP === "MKB" &&
          DeliveryDiscount !== dto_StartupPageLoadInfo.Currency + " 0.00" && (
            <p
              style={{
                fontFamily: F_Fammily.Medium,
                fontSize: "13px",
              }}
            >
              Delivery Discount
            </p>
          )}

        <p
          style={{
            display:
              TotalTax === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
        >
          Tax
        </p>
        <p
          style={{
            fontFamily: F_Fammily.Medium,
            fontSize: "15px",
          }}
        >
          <strong>Total</strong>
        </p>
      </div>
      <div className="pgCartPrice" style={{ marginTop: "5px" }}>
        <p
          style={{
            display: "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
          {...encryptedAmountProps(SubTotal)}
        >
          {SubTotal}
          {""}
        </p>
        <p
          style={{
            display:
              Discount === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
          {...encryptedAmountProps(Discount)}
        >
          {Discount}
        </p>
        <p
          style={{
            display:
              ServiceCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
          {...encryptedAmountProps(ServiceCharge)}
        >
          {ServiceCharge}
        </p>
        <p
          style={{
            display:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK"
                  ? "block"
                  : "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
            color:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? " #457856"
                  : ""
                : "",
            fontWeight:
              DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? CSP === "MK" && dto_common.DineType !== 3
                  ? "bold"
                  : ""
                : "",
          }}
          {...encryptedAmountProps(DeliveryCharge)}
        >
          {DeliveryCharge === dto_StartupPageLoadInfo.Currency + " 0.00"
            ? CSP === "MK" && dto_common.DineType !== 3
              ? "Free"
              : DeliveryCharge
            : DeliveryCharge}
        </p>

        {CSP === "MKB" &&
          DeliveryDiscount !== dto_StartupPageLoadInfo.Currency + " 0.00" && (
            <p
              style={{
                textAlign: "right",
                fontFamily: F_Fammily.Medium,
                fontSize: "13px",
              }}
              {...encryptedAmountProps(DeliveryDiscount)}
            >
              {DeliveryDiscount}
            </p>
          )}

        <p
          style={{
            display:
              TotalTax === dto_StartupPageLoadInfo.Currency + " 0.00"
                ? "none"
                : "block",
            textAlign: "right",
            fontFamily: F_Fammily.Medium,
            fontSize: "13px",
          }}
          {...encryptedAmountProps(TotalTax)}
        >
          {TotalTax}
        </p>
        <p
          style={{
            fontFamily: F_Fammily.Medium,
            fontSize: "15px",
          }}
          {...encryptedAmountProps(GrandTotal)}
        >
          <strong>{GrandTotal}</strong>
        </p>
        <button
          style={{
            color: "#ff0000",
            border: 0,
            background: "none",
            fontFamily: F_Fammily.Medium,
            fontSize: "14px",
            cursor: "pointer",
            display: "block",
          }}
          onClick={() => {
            Clear();
          }}
        >
          Clear Cart
        </button>
      </div>
    </div>
  );
}

export default PriceDetail;
